/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */

export type KpiScope = (typeof KpiScope)[keyof typeof KpiScope];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const KpiScope = {
  TASK: "TASK",
  DELIVER_OBJECT: "DELIVER_OBJECT",
  PHASE: "PHASE",
  MILESTONE: "MILESTONE",
  RELEASE: "RELEASE",
  SPRINT: "SPRINT",
  PROJECT: "PROJECT",
} as const;
